// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectedValue_container__3aBGk","title":"SelectedValue_title__1mLeN","content":"SelectedValue_content__39aK5","headers":"SelectedValue_headers__2Pck_"};